import { resolveProductUrl } from '@podus/utils';

const ALLOWED_DOMAINS = [
    'localhost',
    'podus.ai',
    'www.podus.ai',
    'chat.podus.ai',
    'contract.podus.ai',
    'app.podus.ai',
    'appointment.podus.ai',
    'checker.podus.ai',
    'multidoor.podus.ai',
    'www.multidoor.podus.ai',
    'app.podus.org',
    'podus.org',
    'www.podus.org',
    'harmlist.com',
    'www.harmlist.com',
    'ipvp.citizensgavel.org',
];

// Hosts that have no authenticated UX of their own — a successful sign-in
// coming from one of these should land the user on the app they're most
// likely headed to, not back on the marketing page.
const AUTH_LANDING_REWRITES: Record<string, string> = {
    'podus.ai': 'https://chat.podus.ai',
    'www.podus.ai': 'https://chat.podus.ai',
};

export function isAllowedRedirect(url: string): boolean {
    try {
        const parsed = new URL(url);
        return ALLOWED_DOMAINS.includes(parsed.hostname);
    } catch {
        return false;
    }
}

export function buildRedirectUrl(baseUrl: string, token: string, userId?: string): string {
    let effective = baseUrl;
    try {
        const parsed = new URL(baseUrl);
        const rewrite = AUTH_LANDING_REWRITES[parsed.hostname];
        if (rewrite) effective = rewrite;
    } catch {
        // malformed URL — fall through; resolveProductUrl will handle it
    }
    const resolved = resolveProductUrl(effective);
    const url = new URL(resolved);
    url.searchParams.set('accessToken', token);
    if (userId) url.searchParams.set('uid', userId);
    return url.toString();
}
